<div class="search-container" role="search">
  <div class="search-wrapper">
   <!--  <img
      loading="lazy"
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/6675071628f844c02193446fd81137c106b2a44e7465d2a600e34f150577c846?placeholderIfAbsent=true&apiKey=e0610d2e0dd44efb90054caf4c51f5a1"
      class="search-icon"
      alt=""
    /> -->
       <i-feather name="search" class="search-icon"></i-feather>
    <input
      type="text"
      class="search-input"
      placeholder="{{'Search'|translate}}"
      aria-label="Search Product"
      [(ngModel)]="searchQuery"
      (input)="filterProducts()"
    />
  </div>
  <div class="dropdown" *ngIf="searchQuery.length > 0 && !optionHidden">
    <ul *ngIf="filteredProducts.length > 0">
      <li
        class="dropdown-item"
        *ngFor="let product of filteredProducts; let i = index"
         [ngClass]="{'selected': i === selectedIndex}"
         (click)="navigateToProduct(i,product.item)">

        <img [src]="getDefaultImage(product.Images)" alt="Product Image" />

        <span>{{ product.item }}</span>
        <a >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
              fill="white"
            />
          </svg>
        </a>
      </li>
    </ul>
    <div class="no-results" *ngIf="filteredProducts.length === 0">
      <i class="feather icon-alert-triangle"></i>
      <span> {{'CfHome.ProductNotFound' | translate}}</span>
    </div>
  </div>
</div>
